import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import type { TLlmTechnicalDetails } from '@/_core/entities/vulnerability/models/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'VulnerabilityTechnicalDetails',
  props: {
    technicalDetails: null
  },
  setup(__props: any) {

const props = __props as {
  technicalDetails: TLlmTechnicalDetails | null;
};



const FIELD_LABELS: Record<keyof TLlmTechnicalDetails, string> = {
  summary: 'Summary',
  attackVector: 'Attack Vector',
  attackLocality: 'Attack Locality',
  privilegesRequired: 'Privileges Required',
  userInteraction: 'User Interaction',
  scope: 'Scope',
  confidentialityImpact: 'Confidentiality Impact',
  integrityImpact: 'Integrity Impact',
  availabilityImpact: 'Availability Impact',
};

const FIELD_ORDER = Object.keys(FIELD_LABELS) as (keyof TLlmTechnicalDetails)[];

const fields = computed(() => {
  if (!props.technicalDetails) return [];
  const details = props.technicalDetails;
  return FIELD_ORDER.filter((key) => details[key] !== null).map((key) => ({
    key,
    label: FIELD_LABELS[key],
    value: details[key] as string,
  }));
});

return { __sfc: true,props, FIELD_LABELS, FIELD_ORDER, fields }
}

})